export const formatMoney = (amount: string | number, fixed: number = 2) => {
  return parseFloat((+String(amount)).toFixed(fixed));
};

export const getAvgValue = (...values: number[]) => {
  return values.reduce((a, b) => a + b) / values.length;
};
